<template>
  <span :style="{ width: width }">
    <div v-if="service.params && service.params.length">
      定值参数：
      <br />
      <div
        v-for="(ff, index) in service.params"
        :key="'n' + index"
        class="sw-custom-field"
      >
        <span>{{ ff.name }}：{{ ff.value }}</span>
      </div>
    </div>

    <div v-if="service.variables && service.variables.length">
      <br />
      不定值参数：
      <br />
      <div
        v-for="(ff, index) in service.variables"
        :key="'v' + index"
        class="sw-custom-field"
      >
        <span>{{ ff.name }}</span>
      </div>
    </div>
    <el-select
      v-model="value"
      @change="selService"
      clearable
      filterable
      style="margin-top: 10px"
      placeholder="请选择接口"
    >
      <el-option
        v-for="item in options"
        :key="item.id"
        :label="item.interfacename"
        :value="item.id"
      ></el-option>
    </el-select>
    <el-button
      v-if="!showDetail"
      @click="openOrClose"
      type="text"
      class="sw-custom-btn"
    >
      详情
      <i class="el-icon-caret-bottom"></i>
    </el-button>
    <el-button
      v-if="showDetail"
      @click="openOrClose"
      type="text"
      class="sw-custom-btn"
    >
      收起
      <i class="el-icon-caret-top"></i>
    </el-button>
    <div v-if="showDetail">
      <el-row>
        <el-col>
          <span style="font-weight: bold">返回字段：</span>
        </el-col>
      </el-row>
      <div style="width: 100%">
        <div v-for="ff in service.fields" :key="ff" class="sw-custom-field">
          <span>{{ ff }}</span>
        </div>
      </div>
      <el-row>
        <el-col>
          <span style="font-weight: bold">接口查询结果：</span>
        </el-col>
      </el-row>
      <div id="testResult" style="height: 200px; width: 100%">
        {{ service.testResult }}
      </div>
    </div>
  </span>
</template>

<script>
import customUtil from '../../../util/customUtil'
import alertUtils from '../../../util/alertUtils'
export default {
  name: 'api-select',
  props: [
    'id',
    'selValue',
    'result',
    'width',
    'params',
    'configOptions',
    'configVariables',
  ],
  data() {
    return {
      value: this.selValue,
      options: this.configOptions,
      service: {
        resultInfo: null, // 选中接口详情数据
        testResult: null, // 测试返回结果
        fields: this.result, // 返回字段列表
        params: this.params, // 请求参数
        variables: this.configVariables,
      },
      showDetail: false,
    }
  },
  created() {
    if (this.id) {
      this.optionInit()
      if (this.value) {
        this.getServiceInfo()
        this.getResult()
      }
    } else {
      alertUtils.alertError('设计ID未获取，请获取设计ID再进行操作', true)
    }
  },
  methods: {
    optionInit() {
      // 选项初始化
      if (this.options && this.options.length > 0) {
        return
      }
      customUtil.getDataInterface(this.id, this.options)
    },
    selService() {
      // 接口选择值改变时； 触发
      if (this.value) {
        this.getServiceInfo()
        this.getResult()
      } else {
        this.service.resultInfo = null
        this.service.testResult = null
        this.service.fields = []
        this.service.params = []
        this.service.variables = []
      }
      this.showDetail = false
    },
    getServiceInfo() {
      // 查询接口详情
      customUtil.getDataInterfaceInfo(this.value, this.service)
    },
    getResult() {
      // 查询结果数据
      customUtil.requestInterface(this.value, this.service)
    },
    openOrClose() {
      if (!this.value) {
        customUtil.alertWarning('请选择接口', true)
        return
      }
      this.showDetail = !this.showDetail // 先翻转 ，后续逻辑倒过来
      if (this.showDetail) {
        // 表示当前是 收起状态， 将要展开 详情
        if (
          this.service.resultInfo === null ||
          this.service.testResult === null
        ) {
          // 先 判断是否存在值，存在就不查询
          this.getServiceInfo()
          this.getResult()
        }
        this.initTest()
      }
    },
    initTest() {
      this.$nextTick(() => {
        const editor = window.ace.edit('testResult')
        editor.session.setMode('ace/mode/json')
      })
    },
  },
  watch: {
    value: {
      handler(val) {
        this.$emit('update:selValue', val)
      },
    },
    options: {
      handler(val) {
        this.$emit('update:configOptions', val)
      },
      deep: true,
    },
    'service.fields': {
      handler(val) {
        this.$emit('update:result', val)
      },
      deep: true,
    },
    'service.params': {
      handler(val) {
        this.$emit('update:params', val)
      },
      deep: true,
    },
    'service.variables': {
      handler(val) {
        this.$emit('update:configVariables', val)
      },
      deep: true,
    },
  },
}
</script>

<style scoped>
.sw-custom-btn {
  margin-left: 10px;
}
.sw-custom-field {
  border-radius: 6px;
  float: left;
  color: white;
  background-color: #409eff;
  margin-left: 10px;
}
.sw-custom-field span {
  padding: 6px;
}
</style>
